// Safari doesn't 'announce' to the world that it behaves badly with :hover, so we have to check the userAgent
if (!navigator.userAgent.match(/(iPad|iPhone|iPod)/g)) {
    $('html').addClass('hoverOk');
}

$(document).ready(function () {
    window.viewportUnitsBuggyfill.init();

    var navbar = $('.navbar');
    var menuBtn = $('.navbar__menuBtn');
    menuBtn.click(function () {
        navbar.toggleClass('navbar--open');
    });


    $('.datepicker').each(function () {
        var picker = new Pikaday({
            field: this,
            format: 'YYYY-MM-DD',
            i18n: {
                previousMonth: 'Předchozí měsíc',
                nextMonth: 'Další měsíc',
                months: ['Leden', 'Únor', 'Březen', 'Duben', 'Květen', 'Červen', 'Červenec', 'Srpen', 'Září', 'Říjen', 'Listopad', 'Prosinec'],
                weekdays: ['Nedělě', 'Pondělí', 'Úterý', 'Středa', 'Čtvrtek', 'Paték', 'Sobota'],
                weekdaysShort: ['Ne', 'Po', 'Út', 'St', 'Čt', 'Pá', 'So']
            }
        });
    });

});


